import React from 'react';
import IntroSection from './components/IntroSection';
import StepsSection from './components/StepsSection';
import CarBrand from './components/CarBrand';
import WebSystem from './components/WebSystem';
import NavigateBar from './components/NavigateBar';
import MobileApp from './components/MobileApp';
import BussinesSupport from './components/BussinesSupport';
import Offer from './components/Offer';
import Support from './components/Support';
import Footer from './components/Footer';
import AllParts from './components/AllParts';

const OnboardingHomePage = () => {
  return (
    <div className="onboarding-home" style={styles.mainContainer}>
      <NavigateBar />
      <IntroSection />
      <StepsSection />
      <CarBrand />
      <WebSystem />
      <MobileApp />
      <BussinesSupport />
      <Offer />
      <Support />
      <AllParts />
      <Footer />
    </div>
  );
};

export default OnboardingHomePage;

const styles = {
  mainContainer: {
    backgroundColor: 'rgb(23, 23, 24)',
    minHeight: '100vh'
  }
};
